@use "~theme/typography";

.label {
  @include typography.caption-semibold;
  background-color: var(--Brand-Blue, var(--info-blue-01));
  border: 1px solid var(--blue-02-at-30);
  border-radius: 4px;
  display: flex;
  margin-bottom: 12px;
  cursor: pointer;
  user-select: none;

  &:focus-within {
    border: 1px solid var(--blue-02);
  }

  @media screen and (max-width: 991px) {
    align-items: center;
    border: 0;
    gap: 8px;
    margin-bottom: 0;
    padding: 12px;
    margin-top: 10px;
  }
}

.checkboxContainer {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
  margin: 10px 8px;

  @media screen and (max-width: 991px) {
    flex: 0 0 20px;
    margin: 0;
    width: 20px;

    > div,
    > div > div {
      height: 20px;
      width: 20px;
    }

    > div > div {
      background-size: 20px 20px;
    }
  }
}

.text {
  padding: 12px;
  background-color: var(--Brand-Blue, var(--info-blue-01));
  font-family: Montserrat;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0%;
  color: var(--brand-indigo);

  @media screen and (max-width: 991px) {
    background-color: transparent;
    flex: 1 1 auto;
    padding: 0;
  }

  :focus-within > & {
    border-left: none;
  }
}
